import { Component, OnInit } from '@angular/core';
import { BizzCalcMonitoringService } from './services/bizz-calc-monitoring.service';
import { register } from 'swiper/element/bundle';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit{
  constructor(private bizzCalcMonitoringService: BizzCalcMonitoringService){

  }
  title(title: any) {
    throw new Error('Method not implemented.');
  }
  async ngOnInit() {
    register();
  }
}
